<template>
  <div>
    <div class="row">
      <div class="col-6">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            id="serviceSpecialist"
            v-model="value.serviceSpecialist"
            :disabled="disabled"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Especialista de Servicio: "
            name="serviceSpecilist"
            :options="serviceSpecialists"
            placeholder="Seleccione..."
            @input="$emit('getSpecialistDetail')"
          />
        </validation-provider>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            id="writerSpecialist"
            v-model="value.writerSpecialist"
            custom-error-msg="Favor de seleccionar la persona que redactó el resumen de resultado."
            :disabled="disabled"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Persona que redactó el resumen de resultados: "
            name="writerSpecialist"
            :options="writerSpecialists"
            placeholder="Seleccione..."
          />
        </validation-provider>
        <hr />
      </div>
    </div>
    <div v-if="!isNewFeaturesImprovementEnabled" class="row col-md-12">
      <div class="row bg-white w-100" style="min-height: 8vh">
        <div class="col-md-4 mt-4">
          <div class="color-secondary-6 font-14">
            Especialista de Servicio:
          </div>
          <span class="color-black font-16 font-weight-bold">
            {{ serviceSpecialistSelected.fullName }}
          </span>
        </div>
        <div class="col-md-4 mt-4">
          <div class="color-secondary-6 font-14">
            Numero de Licencia:
          </div>
          <span class="color-black font-16">
            {{ serviceSpecialistSelected.licenceNo }}
          </span>
        </div>
        <div class="col-md-4 mt-4">
          <div class="color-secondary-6 font-14">
            Fecha de Expiración:
          </div>
          <span class="color-black font-16">
            {{ serviceSpecialistSelected.expirationDate }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';

export default {
  components: {
    CustomDropDown,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    serviceSpecialists: {
      type: Array,
      default: () => [],
    },
    writerSpecialists: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    isNewFeaturesImprovementEnabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  computed: {
    serviceSpecialistSelected() {
      const defaultValue = { fullName: '', licenceNo: '', expirationDate: '' };
      return this.value && this.value.selectedServiceSpecialist
        ? this.value.selectedServiceSpecialist
        : defaultValue;
    },
  },
};
</script>
